import { Component, computed, input, OnInit } from '@angular/core';
import {
	capitalise,
	ClearingService,
	replaceDashWithSpace,
	SeoMetadataService,
} from '@uc/utilities';

import { getDegreeLevelOptions } from '../../utils/utils';
import { Store } from '@ngrx/store';

import { DegreeLevelOption } from '@uc/web/shared/data-models';
import { CLEARING_DEGREE_LEVEL_LABELS } from '../../static/courses-filter.properties';
import { fetchClearingCourses } from '../../data-access/+store/course-search.actions';
import { ClearingHeaderComponent } from '../../components/clearing-header/clearing-header.component';
import { CLEARING_ENABLED } from '@uc/web/config';

@Component({
	selector: 'uc-clearing-course-search',
	templateUrl: './clearing-course-search.component.html',
	imports: [ClearingHeaderComponent],
})
export class ClearingCourseSearchComponent implements OnInit {
	subject = input.required<string>();

	formattedSubject = computed(() => replaceDashWithSpace(this.subject()));

	currentYear = new Date().getFullYear();
	degreeLevelOptions!: DegreeLevelOption[];
	clearingEnabled = CLEARING_ENABLED;

	constructor(
		private _store: Store,
		private _seoSrv: SeoMetadataService,
		public _clearingSrv: ClearingService,
	) {}

	ngOnInit(): void {
		this._seoSrv.updateTitle(
			`${capitalise(this.formattedSubject())} Clearing Courses ${this.currentYear}`,
		);
		const clearingStartDate = this._clearingSrv.getStartDateString();
		this._seoSrv.updateDescription(
			`Compare the best ${this.formattedSubject()} undergraduate courses in the UK and check back on ${clearingStartDate} for Clearing courses - read course reviews, course requirements and more.`,
		);
		this.degreeLevelOptions = getDegreeLevelOptions([
			...CLEARING_DEGREE_LEVEL_LABELS,
		]);
		this._store.dispatch(fetchClearingCourses());
	}
}
